import { Delete, Edit, Trash } from "lucide-react";
import { useState } from "react";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

const SCHOOL_LEVEL_IDS = [62, 8, 60, 66]; // Class 9–12

const AcademicCard = ({ academic, onEdit, onDelete }) => {
  const [open, setOpen] = useState(false);
  const getStatusColor = (status) => {
    switch (status) {
      case "Complete":
        return "text-green-600"; // Completed
      case "Pursuing":
        return "text-red-500"; // Pending
      default:
        return "text-gray-500";
    }
  };

  const isSchoolLevel = SCHOOL_LEVEL_IDS.includes(academic.gl_course_level_id);

  return (
    <div className="rounded-md ">
      <div className="flex justify-between items-start mb-2 border-t pt-4">
        <h3 className="text-lg font-medium text-[#572575] font-inter">
          {academic.course_level_name} Details
        </h3>
        <div className="flex items-center gap-4">
          <button
            onClick={() => onEdit(academic)}
            className="flex items-center text-[#007BFF] font-bold"
          >
            <Edit className="h-5 w-5 mr-1" /> Edit
          </button>
          <button
            // onClick={() => onDelete(academic.id)}
            onClick={() => setOpen(true)}
            className="flex items-center text-[#DF252A] font-bold"
          >
            <Trash className="h-5 w-5 mr-1" /> Delete
          </button>
        </div>
      </div>

      <ConfirmDeleteModal
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={() => {
          onDelete(academic.id);
          setOpen(false);
        }}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4  pb-4 font-inter mb-6">
        {/* Common: Level */}

        {isSchoolLevel ? (
          <>
            <div className="">
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Level:</span>
                <p className="text-black">
                  {academic.course_level_name || "N/A"}
                </p>
              </div>
              {/* School-level fields in correct order */}

              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Stream:</span>
                <p className="text-black">{academic.stream_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Education Status:
                </span>
                <p className={getStatusColor(academic.education_status)}>
                  {academic.education_status}
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  {academic.marks_type === 1 ? "Percentage:" : "CGPA:"}
                </span>
                <p className="text-black">
                  {academic.percentage || "N/A"}
                  {academic.marks_type === 1 ? "%" : ""}
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Year of Passing:
                </span>
                <p className="text-black">
                  {academic.year_of_passing || "N/A"}
                </p>
              </div>
            </div>
            <div className="">
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">School Name:</span>
                <p className="text-black">
                  {academic.university_name || "N/A"}
                </p>
              </div>
              {/* Location */}
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">City:</span>
                <p className="text-black">{academic.city_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">State:</span>
                <p className="text-black">{academic.state_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Country:</span>
                <p className="text-black">{academic.country_name || "N/A"}</p>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Degree-level fields */}
            <div className="">
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Level:</span>
                <p className="text-black">
                  {academic.course_level_name || "N/A"}
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Qualification:
                </span>
                <p className="text-black">
                  {academic.gl_qualification_name || "N/A"}
                </p>
              </div>

              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Stream:</span>
                <p className="text-black">{academic.stream_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Duration:</span>
                <p className="text-black">
                  {academic.course_duration || "N/A"} Years
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Education Status:
                </span>
                <p className={getStatusColor(academic.education_status)}>
                  {academic.education_status}
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  {academic.marks_type === 1 ? "Percentage:" : "CGPA:"}
                </span>
                <p className="text-black">
                  {academic.percentage || "N/A"}
                  {academic.marks_type === 1 ? "%" : ""}
                </p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Year of Passing:
                </span>
                <p className="text-black">
                  {academic.year_of_passing || "N/A"}
                </p>
              </div>
              {academic.number_of_backlogs !== null && (
                <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                  <span className="text-[#727271] font-medium">
                    Number of Backlogs:
                  </span>
                  <p className="text-black">
                    {academic.number_of_backlogs || "N/A"}
                  </p>
                </div>
              )}
            </div>

            <div className="">
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">
                  Institution Name:
                </span>
                <p className="text-black">
                  {academic.university_name || "N/A"}
                </p>
              </div>

              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Affiliation:</span>
                <p className="text-black">
                  {academic.affiliation_name || "N/A"}
                </p>
              </div>
              {/* Location */}
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">City:</span>
                <p className="text-black">{academic.city_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">State:</span>
                <p className="text-black">{academic.state_name || "N/A"}</p>
              </div>
              <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
                <span className="text-[#727271] font-medium">Country:</span>
                <p className="text-black">{academic.country_name || "N/A"}</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AcademicCard;
